<template>
  <v-card class="px-10 py-5">
    <v-card-title class="headline">
      Create Retail Lab Door
    </v-card-title>
    <v-progress-circular
      v-if="isLoading"
      :size="60"
      :width="8"
      class="d-block mx-auto mt-16"
      indeterminate
      color="primary"
    />
    <v-form
      v-if="!isLoading"
      ref="form"
      v-model="formRetailLabRegion.valid"
    >
      <v-col>
        <v-text-field
          v-model="formRetailLabRegion.name"
          :rules="formRetailLabRegion.nameRules"
          label="Retail Lab Door Name"
          required
        />
      </v-col>
      <v-card-actions>
        <v-spacer />
        <v-btn color="red darken-2" text :disabled="isLoading" @click="$emit('close')">
          Cancel
        </v-btn>
        <v-btn
          color="light-blue darken-2"
          :disabled="isLoading"
          text
          @click="doCreateRetailLabRegion"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { createRetailLabRegion } from 'API/retailLabRegion';

export default {
  data: () => ({
    isLoading: false,
    formRetailLabRegion: {
      valid: true,
      name: '',
      nameRules: [
        (v) => !!v || 'Full Name is required',
      ],
    },
    error: {
      status: false,
      message: '',
    },
  }),
  methods: {
    async doCreateRetailLabRegion() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;
      const { __raw: jwt = '' } = await this.$auth.getIdTokenClaims();
      const body = {
        name: this.formRetailLabRegion.name,
      };

      try {
        const res = await createRetailLabRegion(jwt, body);
        this.$emit('created', res.data);
        this.$emit('close');
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
      } catch (error) {
        this.error.status = true;
        this.error.message = error;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
